export function normalizeCollectionResponse(data) {
  if (Array.isArray(data)) {
    return { items: data, count: data.length, paginated: false }
  }
  if (data && Array.isArray(data.results)) {
    return {
      items: data.results,
      count: Number.isFinite(data.count) ? data.count : data.results.length,
      paginated: true
    }
  }
  return { items: [], count: 0, paginated: false }
}

export function collectUniqueMissingIds(appointments, field, cache = {}) {
  return [...new Set(
    (appointments || [])
      .map(appointment => appointment?.[field])
      .filter(id => id && !cache[id])
  )]
}

export function normalizeNurseCall(call) {
  return {
    ...call,
    call_type: 'nurse_call',
    video_room_url: call?.room_url || call?.video_room_url || null
  }
}
